import {NavigateFunction} from 'react-router-dom';
import {savaquanFetch, savaquanFetchJson} from '../../shared/services/http.service';
import {
  AddCompanyUserAssignmentDto,
  CompanyUserAssignmentDto,
  SendTeamInviteDto,
  UpdateCompanyUserAssignmentDto,
} from './dtos/company-user-assignment.dto';

const baseUrl = `${process.env.REACT_APP_ACCUSITE_API_BASE_URL}/api/v1/company-user-assignments`;

export const getCompanyUserAssignments = (navigate: NavigateFunction) =>
  savaquanFetchJson<CompanyUserAssignmentDto[]>(baseUrl, {navigate});

export const addCompanyUserAssignment = (
  navigate: NavigateFunction,
  assignment: AddCompanyUserAssignmentDto,
) =>
  savaquanFetchJson<CompanyUserAssignmentDto>(baseUrl, {
    navigate,
    method: 'POST',
    body: JSON.stringify(assignment),
  });

export const updateCompanyUserAssignment = (
  navigate: NavigateFunction,
  id: number,
  assignment: UpdateCompanyUserAssignmentDto,
) =>
  savaquanFetchJson<CompanyUserAssignmentDto>(`${baseUrl}/${id}`, {
    navigate,
    method: 'PUT',
    body: JSON.stringify(assignment),
  });

export const deleteCompanyUserAssignment = (navigate: NavigateFunction, id: number) =>
  savaquanFetch(`${baseUrl}/${id}`, {navigate, method: 'DELETE'}).then(() => undefined);

export const setCompanyUserAssignmentActive = (navigate: NavigateFunction, id: number, active: boolean) =>
  savaquanFetchJson<CompanyUserAssignmentDto>(`${baseUrl}/${id}/active`, {
    navigate,
    method: 'PUT',
    body: JSON.stringify({active}),
  });

export const sendCompanyUserAssignmentInvite = (
  navigate: NavigateFunction,
  id: number,
  invite: SendTeamInviteDto,
) =>
  savaquanFetch(`${baseUrl}/${id}/invite`, {
    navigate,
    method: 'POST',
    body: JSON.stringify(invite),
  }).then(() => undefined);
